import { useContext } from 'react';
import { BFContext } from 'contexts/bienesFiscalesContext/BFContext';

export const useBFContext = () => {
	return useContext(BFContext);
};
